import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  Badge,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import { formatDate } from "../../../../utils/dateUtils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

// modo "apartados": reporte completo (crear/editar/liquidar/eliminar).
// modo "anticipos": pantalla de cobro ("Anticipos Tiendas") solo para quien recibe
// el dinero: lista los apartados pendientes y unicamente permite abonar.
function ListadoApartadosTiendas({ modo = "apartados" }) {
  const esAnticipos = modo === "anticipos";
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_VENTAS_TIENDAS = import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_ABONOS_TIENDAS = import.meta.env.VITE_URL_ABONOS_TIENDAS;
  const URL_ANTICIPOS = import.meta.env.VITE_URL_ANTICIPOS;
  const URL_CAJAS = import.meta.env.VITE_URL_CAJAS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;

  let date = new Date()
  let hoy = moment(date).format("YYYY-MM-DD"); 

  const [ventasTiendas, setVentasTiendas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [paqueteria, setPaqueteria] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(hoy);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);
  const [fecha, setFecha] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  
  const [areas, setAreas] = useState([]);
  const [selectedAreaFiltro, setSelectedAreaFiltro] = useState("");
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transferencia, setTransferencia] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // ── Abonos (embebido, estilo Gloss: todo en la misma pantalla, sin
  // validacion/autorizacion posterior — el abono cuenta al instante) ──
  const [modalAbonos, setModalAbonos] = useState(false);
  const toggleAbonos = () => setModalAbonos(!modalAbonos);
  const [apartadoSel, setApartadoSel] = useState(null);
  const [cajasApartado, setCajasApartado] = useState([]);
  const [cajaAbono, setCajaAbono] = useState("");
  const [abonosExistentes, setAbonosExistentes] = useState([]);
  const [cargandoAbonos, setCargandoAbonos] = useState(false);
  const [abonoData, setAbonoData] = useState({
    efectivo: 0,
    tdc: 0,
    transfer: 0,
    destino: "NA",
    fechaTransfer: "NA",
    terminal: "NA",
    observaciones: "NA",
  });
  const [guardandoAbono, setGuardandoAbono] = useState(false);

  // ── Liquidar (embebido en el mismo listado): jala el apartado, resta
  // los abonos ya pagados, pide forma de pago del resto, y solo si el
  // saldo queda en $0 descuenta inventario y marca entregado ──
  const [modalLiquidar, setModalLiquidar] = useState(false);
  const toggleLiquidar = () => setModalLiquidar(!modalLiquidar);
  const [cajaLiquidar, setCajaLiquidar] = useState("");
  const [liquidarData, setLiquidarData] = useState({
    efectivo: 0,
    tdc: 0,
    transfer: 0,
    destino: "NA",
    fechaTransfer: "NA",
    terminal: "NA",
  });
  const [guardandoLiquidar, setGuardandoLiquidar] = useState(false);

  // ── Editar Apartado: quitar/agregar prendas antes de liquidar. Como el
  // inventario no se descuenta hasta liquidar, editar aqui es seguro -- solo
  // ajusta los renglones y recalcula los totales de la venta.
  const [modalEditar, setModalEditar] = useState(false);
  const toggleEditar = () => setModalEditar(!modalEditar);
  const [editarLineas, setEditarLineas] = useState([]);
  const [editarLineasOriginalesIds, setEditarLineasOriginalesIds] = useState([]);
  const [editarArticulos, setEditarArticulos] = useState([]);
  const [editarNuevoArticulo, setEditarNuevoArticulo] = useState("");
  const [editarInventarioArticulo, setEditarInventarioArticulo] = useState([]);
  const [editarNuevoColor, setEditarNuevoColor] = useState("");
  const [editarNuevoTalla, setEditarNuevoTalla] = useState("");
  const [editarNuevoCantidad, setEditarNuevoCantidad] = useState(0);
  const [editarNuevoPrecio, setEditarNuevoPrecio] = useState(0);
  // Opciones del buscador de articulos del modal de editar. Mismo armado que
  // ApartadosTiendasCreate.jsx (agrupa por letra inicial, numeros en "0-9"),
  // pero `junta` incluye tambien el nombre para poder buscar por cualquiera
  // de los dos, no solo por codigo.
  const opcionesArticulosEditar = useMemo(
    () =>
      editarArticulos
        .filter((a) => a && a.codigo)
        .map((a) => {
          const firstLetter = String(a.codigo)[0].toUpperCase();
          return {
            ...a,
            firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
            junta: `${a.codigo} ${a.nombre || ""}`.trim(),
          };
        })
        .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter)),
    [editarArticulos]
  );
  const [editarPaqueteria, setEditarPaqueteria] = useState(0);
  const [guardandoEditar, setGuardandoEditar] = useState(false);


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    setSelectedArea(user.areas)
    if(user.areas){
    if(user.areas != AREAS_GENERAL){
    axios
      .get(`${URL_VENTAS_TIENDAS}ApartadosDiario/${user.areas}/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idVentaTienda,
              consecutivo: a.prefijo + a.consecutivo,
              activo: a.is_active,
              fecha: a.fecha,
              fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
              colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idColaborador: a.colaboradores[0]._id,
              observaciones: a.observaciones,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              total_cantidad: a.total_cantidad,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              calle: a.clientes[0].calle,
              numero_ext: a.clientes[0].numero_ext,
              numero_int: a.clientes[0].numero_int,
              pais: a.clientes[0].pais,
              estado: a.clientes[0].estado,
              ciudad: a.clientes[0].ciudad,
              delegacion: a.clientes[0].delegacion,
              colonia: a.clientes[0].colonia,
              cp: a.clientes[0].cp,
              paqueteria: a.clientes[0].paqueteria,
              idAreas: a.areas[0]._id,
              area: a.areas[0].name,
              areaSurtido: a.areaSurtido && a.areaSurtido[0] ? a.areaSurtido[0].name : a.areas[0].name,
              condPago: a.cond_pago,
              entregado:a.entregado,
              descuento:a.descuento,
              descuentoNumero: (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
              saldo: a.saldo,
              // Anticipos registrados por administracion y aplicados al crear el apartado.
              anticipoAplicado: (a.anticiposAplicados || []).reduce((t, x) => t + (parseFloat(x.importe) || 0), 0),
              anticiposAplicados: a.anticiposAplicados || [],
              cajaNombre: a.caja?.[0]?.nombre || "—",
              cajero: a.user && a.user[0] ? a.user[0].nombre + " " + a.user[0].apellido : "—",
              rfc: a.clientes[0].RFC || "XAXX010101000",
              telefono: a.clientes[0].telefono,
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setVentasTiendas(data);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      })} else{
        axios
          .get(`${URL_VENTAS_TIENDAS}ApartadosDiarioGeneral/${selectedFechaInicio}/${selectedFechaFin}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allVentas = response.data;
            // Array para pagination
            let arrayTabla = allVentas
              .sort((a, b) => (a.idVentaTienda > b.idVentaTienda ? 1 : -1))
              .map((a) => {
                return {
                  _id: a._id,
                  numero: a.idVentaTienda,
                  consecutivo: a.prefijo + a.consecutivo,
                  activo: a.is_active,
                  fecha: a.fecha,
                  fechaHora: a.fecha + " " + moment(a.createdAt).utcOffset('-0600').format("HH:mm:ss"),
                  colaborador: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
                  idColaborador: a.colaboradores[0]._id,
                  observaciones: a.observaciones,
                  subTotal: a.subTotal,
                  iva: a.iva,
                  total_general: a.total_general,
                  clientes: a.clientes[0].nombre_comercial,
                  idClientes: a.clientes[0]._id,
                  total_cantidad: a.total_cantidad,
                  comisionTDC: a.comisionTDC,
                  comisionFlete: a.comisionFlete,
                  impuestos: a.impuestos,
                  calle: a.clientes[0].calle,
                  numero_ext: a.clientes[0].numero_ext,
                  numero_int: a.clientes[0].numero_int,
                  pais: a.clientes[0].pais,
                  estado: a.clientes[0].estado,
                  ciudad: a.clientes[0].ciudad,
                  delegacion: a.clientes[0].delegacion,
                  colonia: a.clientes[0].colonia,
                  cp: a.clientes[0].cp,
                  paqueteria: a.clientes[0].paqueteria,
                  idAreas: a.areas[0]._id,
                  area: a.areas[0].name,
                  areaSurtido: a.areaSurtido && a.areaSurtido[0] ? a.areaSurtido[0].name : a.areas[0].name,
                  condPago: a.cond_pago,
                  entregado:a.entregado,
                  descuento:a.descuento,
                  descuentoNumero: (parseFloat(a.subTotal) * parseFloat(a.descuento))/100,
                  saldo: a.saldo,
                  anticipoAplicado: (a.anticiposAplicados || []).reduce((t, x) => t + (parseFloat(x.importe) || 0), 0),
                  anticiposAplicados: a.anticiposAplicados || [],
                  cajaNombre: a.caja?.[0]?.nombre || "—",
                  cajero: a.user && a.user[0] ? a.user[0].nombre + " " + a.user[0].apellido : "—",
                  rfc: a.clientes[0].RFC || "XAXX010101000",
                  telefono: a.clientes[0].telefono,
                }
              })
              .filter(function (el) {
                return el != null;
              });
    
            let data = Object.values(arrayTabla);
    
            setVentasTiendas(data);
            setComments(data);
            //
          })
          .catch((err) => {
            console.log(err);
          })}
        }

          axios
          .get(URL_AREAS, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allAreas = res.data;
            setAreas(allAreas);
          })
          .catch((err) => {
            console.log(err);
          });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

   
  }, [user, selectedFechaInicio, selectedFechaFin]);


  function PDFTabla() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        TotalTabla = TotalTabla + a.total_general
        TotalPiezas = TotalPiezas + a.total_cantidad
        return [
          a.numero,
          a.area,
          a.fecha,
          a.user,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 155, 15, 25, 25);

    doc.setFontSize(14)
    doc.text(`Listado Ventas`, 15, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 15, 35);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(TotalPiezas),
          "",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla),
        ]
      ],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        return {
          Numero: a.numero,
          Area: a.area,
          Fecha: a.fecha,
          Vendedor: a.user,
          Cliente: a.clientes,
          Cantidad: a.total_cantidad,
          CondPago: a.condPago,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoVentas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoVentas",
        sheetFilter: [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "CondPago",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalTabla = 0
    let TotalPiezas = 0
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaborador)&&
        (selectedAreaFiltro == 0 || selectedAreaFiltro == a.idAreas)
      ) {
        TotalTabla = TotalTabla + a.total_general
        TotalPiezas = TotalPiezas + a.total_cantidad
        return [
          a.numero,
          a.area,
          a.fecha,
          a.user,
          a.clientes,
          a.total_cantidad,
          a.condPago,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ventas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Area",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Cond Pago",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(TotalPiezas),
          "",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(TotalTabla),
        ]
      ]
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ventas",
          email: mailTo,
          fileName: "ListadoVentas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ventas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

 

  // Ticket de apartado (creacion / abono / liquidacion): copiado de
  // ListadoVentasTiendas.jsx PDFOC. Ese si usa total_general/subTotal/iva
  // guardados en BD (no los recalcula), y jala TODOS los abonos de la venta
  // para mostrar el historial de pagos completo en cada impresion.
  async function PDFOC(
    fecha,
    fechaHora,
    colaborador,
    clientes,
    consecutivo,
    idPDFOC,
    comisionTDC,
    comisionFlete,
    impuestos,
    areaSurtido,
    descuento,
    descuentoNumero,
    condPago,
    idAreas,
    subTotalDB,
    ivaDB,
    totalGeneralDB,
    descuentoTipo,
    cajero,
    cajaNombre,
    // El anticipo NO es un AbonosTiendas (ver AnticiposApartadoService: no se
    // registra como abono para que el estado de cuenta y el corte no lo cuenten
    // dos veces), asi que la tabla de pagos de abajo jamas lo ve. Sin estos dos
    // datos el ticket mostraba Total $6,617 contra pagos por $5,617 y quien
    // empaca creia que faltaba por cobrar. El saldo se recibe ya calculado
    // porque apartadoSel todavia trae el anterior cuando se imprime tras abonar.
    anticipoAplicado = 0,
    saldoFinal = null,
  ) {
    await axios
      .get(`${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosVenta = response.data;
        let arrayTabla = allArticulosVenta
          .map((a) => {
            return {
              idArticulo: a.articulos[0]._id,
              articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              tallaNombre: a.tallas && a.tallas[0] ? a.tallas[0].name : "",
              colorNombre: a.colores && a.colores[0] ? a.colores[0].name : "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            articulos: item.articulos,
            precio: item.precio,
            cantidad: 0,
            total: 0,
            cajas: 0,
            lineas: [],
          };
          groups[val].cantidad += item.cantidad;
          groups[val].total += item.total;
          groups[val].cajas += item.cajas;
          const tallaNombre = item.tallaNombre || "";
          const colorNombre = item.colorNombre || "";
          const lineaExistente = groups[val].lineas.find(
            (l) => l.tallaNombre === tallaNombre && l.colorNombre === colorNombre
          );
          if (lineaExistente) {
            lineaExistente.cantidad += item.cantidad;
            lineaExistente.total += item.total;
          } else {
            groups[val].lineas.push({
              tallaNombre,
              colorNombre,
              cantidad: item.cantidad,
              precio: item.precio,
              total: item.total,
            });
          }
          return groups;
        }, []);

        let dataAgrupado = Object.values(agrupado);

        axios
          .get(`${URL_ABONOS_TIENDAS}/ventasTiendas/${idPDFOC}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allAbonosVenta = response.data;
            let arrayTablaAbonos = allAbonosVenta
              .map((a) => {
                return {
                  efectivo: a.efectivo,
                  tdc: a.tdc,
                  transfer: a.transfer,
                  deposito: a.deposito || 0,
                  cheque: a.cheque || 0,
                  numeroCheque: a.numeroCheque || "NA",
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinalAbonos = Object.values(arrayTablaAbonos);
            const hasDeposito = dataFinalAbonos.some((a) => a.deposito > 0);
            const hasCheque = dataFinalAbonos.some((a) => a.cheque > 0);
            const dataAbonos = dataFinalAbonos.map((a) => {
              const row = [
                new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.efectivo),
                new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.tdc),
                new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.transfer),
              ];
              if (hasDeposito) row.push(new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.deposito));
              if (hasCheque) row.push(new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.cheque), a.numeroCheque);
              return row;
            });
            const dataPDFAbonos = Object.values(dataAbonos);
            const dataPDFAbonosLimpia = dataPDFAbonos.filter(function (el) {
              return el != null;
            });

            let totalKG = dataAgrupado.map((c) => parseFloat(c.cantidad));
            let TK = totalKG.reduce((t, total, index) => t + total, 0);

            let cajas = dataAgrupado.map((c) => parseFloat(c.cajas));
            let TC = cajas.reduce((t, total, index) => t + total, 0);

            let LA = dataFinal.length * 1.5;
            let largoTotal = LA + 4 + 13 + 13;

            let total_general_tabla = 0;
            let iva_tabla = 0;

            const data = dataAgrupado.flatMap((a) => [
              [{ content: a.articulos, colSpan: 3, styles: { fontStyle: "bold", halign: "left", cellPadding: { top: 0.1, bottom: 0, left: 0.1, right: 0.1 } } }],
              ...a.lineas.map((l) => [
                { content: `   ${new Intl.NumberFormat("en-US").format(l.cantidad)} x  ${l.colorNombre} / ${l.tallaNombre}`, colSpan: 3, styles: { halign: "left", fontStyle: "bold", fontSize: 8, cellPadding: { top: 0.05, bottom: 0.05, left: 0.2, right: 0.1 } } },
              ]),
              [
                { content: `Cant: ${new Intl.NumberFormat("en-US").format(a.cantidad)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
                { content: `Precio: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.precio)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
                { content: `Total: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total)}`, styles: { halign: "right", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
              ],
            ]);
            const dataPDF = Object.values(data);
            const dataPDFLimpia = dataPDF.filter(function (el) {
              return el != null;
            });

            let subTotalSinIva = parseFloat(subTotalDB) || 0;
            let descuentoMontoTabla = parseFloat(descuentoNumero) || 0;
            iva_tabla = parseFloat(ivaDB) || 0;
            total_general_tabla = parseFloat(totalGeneralDB) || 0;

            const doc = new jsPDF("p", "cm", [8, largoTotal], true);
            var base64 = qrcode.toDataURL(idPDFOC);
            var img3 = new Image();
            img3.src = base64;

            var img2 = new Image();
            img2.src = "logoInstitucion.png";

            doc.addImage(img2, "png", 5, 1, 2, 2);

            doc.setFontSize(6).setFont(undefined, "bold");
            doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 0.3, 1);
            doc.text(`Sucursal: ${user.areaName}`, 0.3, 1.3);
            doc.text(`Direccion:${user.areaDireccion}`, 0.3, 1.6);
            doc.text(`Atencion al Cliente: ${user.areaTelefono}`, 0.3, 1.9);

            doc.text(`Fecha: ${fechaHora}`, 0.3, 2.5);
            doc.text(`Nota: ${consecutivo} / Almacen: ${areaSurtido} / Caja: ${cajaNombre || "—"}`, 0.3, 2.8);
            doc.text(`Piezas: ${new Intl.NumberFormat("en-US").format(TK)} / Cajas ${TC.toFixed(2)}`, 0.3, 3.1);
            doc.text(`Cliente: ${clientes}`, 0.3, 3.4);
            doc.text(`Vendedor: ${colaborador}`, 0.3, 3.7);
            doc.text(`Cajero: ${cajero || "—"}`, 0.3, 4.0);

            doc.autoTable({
              head: [[{ content: "Articulos", colSpan: 3, styles: { halign: "left" } }]],
              body: dataPDFLimpia,
              styles: { fontSize: 8, overflow: "linebreak" },
              columnStyles: { 0: { cellWidth: 2.4 }, 1: { cellWidth: 2.4 }, 2: { cellWidth: 2.5 } },
              startY: 4.3,
              theme: "plain",
              margin: { left: 0.3, right: 0.3 },
              foot: [
                [{ content: "Total Cajas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TC)],
                [{ content: "Total Piezas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TK)],
                [{ content: "SubTotal s/IVA", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(subTotalSinIva)],
                [{ content: `Descuento ${(descuentoTipo || "%") === "$" ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuentoMontoTabla) : `${descuento}%`}`, colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuentoMontoTabla)],
                [{ content: "IVA (16%)", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(iva_tabla)],
                [{ content: "Comision TDC", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionTDC)],
                [{ content: "Paquetería", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionFlete)],
                [{ content: "Total", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(total_general_tabla)],
                ...(parseFloat(anticipoAplicado) > 0
                  ? [[{ content: "Anticipo", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(-parseFloat(anticipoAplicado))]]
                  : []),
                ...(saldoFinal !== null && saldoFinal !== undefined
                  ? [[{ content: "Saldo", colSpan: 2, styles: { halign: "left", fontStyle: "bold" } }, { content: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(parseFloat(saldoFinal) || 0), styles: { fontStyle: "bold" } }]]
                  : []),
              ],
              showFoot: "lastPage",
            });

            doc.autoTable({
              head: [
                [
                  "Efectivo",
                  "TDC",
                  "Transfer",
                  ...(hasDeposito ? ["Depósito"] : []),
                  ...(hasCheque ? ["Cheque", "No. Cheque"] : []),
                ],
              ],
              body: dataPDFAbonosLimpia,
              styles: { fontSize: 8 },
              startY: doc.autoTable.previous.finalY + 0.5,
              theme: "plain",
              margin: { left: 0.3, right: 0.7 },
            });

            if (condPago == "Credito") {
              doc.text(`Firma: ________________`, 0.3, doc.autoTable.previous.finalY + 0.7);
            }

            let leyendaY = doc.autoTable.previous.finalY + (condPago == "Credito" ? 1.2 : 0.7);
            doc.setFontSize(7);
            doc.text(
              "CAMBIOS POR MODELO ANTES DE LOS 15 DÍAS HABIENDO EXISTENCIA.",
              doc.internal.pageSize.getWidth() / 2,
              leyendaY,
              { align: "center", maxWidth: doc.internal.pageSize.getWidth() - 0.6 }
            );

            window.open(doc.output("bloburl"), "_blank");
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Documento de apartado de pagina completa (A4), estilo "Cotizacion" de
  // Ventas/Pedidos -- copiado de ListadoPedidos.jsx PDFOC y adaptado a los
  // datos de VentasTiendas (sin los campos de autorizacion de Pedidos, que
  // no existen para apartados). Este es el que dispara el boton de PDF del
  // listado; el ticket angosto (funcion PDFOC de arriba) sigue siendo el que
  // se imprime automatico al crear/abonar/liquidar.
  async function PDFCotizacion(a) {
    const auth = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      const [artRes, abonosRes] = await Promise.all([
        axios.get(`${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${a._id}`, { headers: auth }),
        axios.get(`${URL_ABONOS_TIENDAS}/ventasTiendas/${a._id}`, { headers: auth }).catch(() => ({ data: [] })),
      ]);

      let allArticulosVenta = artRes.data;
      let arrayTabla = allArticulosVenta
        .map((art) => ({
          idArticulo: art.articulos[0]._id,
          articulos: art.articulos[0].codigo + " - " + art.articulos[0].nombre,
          cantidad: art.cantidad,
          precio: art.precio,
          total: art.total,
          tallaNombre: art.tallas && art.tallas[0] ? art.tallas[0].name : "",
          colorNombre: art.colores && art.colores[0] ? art.colores[0].name : "",
        }))
        .filter(Boolean);

      // Se agrupa por articulo y, dentro de cada uno, una linea por
      // color/talla -- mismo desglose que ya trae el ticket (PDFOC). Antes
      // esta cotizacion solo mostraba el total del modelo y no se sabia que
      // tallas ni que colores llevaba.
      let agrupado = arrayTabla.reduce(function (groups, item) {
        const val = item.idArticulo;
        groups[val] = groups[val] || { idArticulo: val, articulos: item.articulos, precio: item.precio, cantidad: 0, total: 0, lineas: [] };
        groups[val].cantidad += item.cantidad;
        groups[val].total += item.total;
        const tallaNombre = item.tallaNombre || "";
        const colorNombre = item.colorNombre || "";
        const lineaExistente = groups[val].lineas.find(
          (l) => l.tallaNombre === tallaNombre && l.colorNombre === colorNombre
        );
        if (lineaExistente) {
          lineaExistente.cantidad += item.cantidad;
          lineaExistente.total += item.total;
        } else {
          groups[val].lineas.push({ tallaNombre, colorNombre, cantidad: item.cantidad, total: item.total });
        }
        return groups;
      }, {});
      let dataAgrupado = Object.values(agrupado);
      let TK = dataAgrupado.reduce((t, r) => t + parseFloat(r.cantidad || 0), 0);

      const sangria = { top: 0.5, bottom: 0.5, left: 6, right: 2 };
      const dataPDFLimpia = dataAgrupado
        .sort((x, y) => (x.articulos > y.articulos ? 1 : -1))
        .flatMap((r) => [
          [
            { content: r.articulos, styles: { fontStyle: "bold" } },
            { content: new Intl.NumberFormat("en-US").format(r.cantidad), styles: { fontStyle: "bold" } },
            new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(r.precio),
            { content: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(r.total), styles: { fontStyle: "bold" } },
          ],
          // Desglose: COLOR / TALLA con su cantidad. Precio y total se dejan en
          // blanco porque ya van en el renglon del articulo.
          // Un concepto sin color ni talla (un flete, por ejemplo) no se
          // desglosa: no hay nada que desglosar.
          ...r.lineas
            .filter((l) => l.colorNombre || l.tallaNombre)
            .sort((x, y) =>
              x.colorNombre === y.colorNombre
                ? (x.tallaNombre > y.tallaNombre ? 1 : -1)
                : (x.colorNombre > y.colorNombre ? 1 : -1)
            )
            .map((l) => [
              {
                content: [l.colorNombre, l.tallaNombre].filter(Boolean).join(" / "),
                styles: { fontSize: 9, textColor: [90, 90, 90], cellPadding: sangria },
              },
              { content: new Intl.NumberFormat("en-US").format(l.cantidad), styles: { fontSize: 9, textColor: [90, 90, 90] } },
              "",
              "",
            ]),
        ]);

      // Pagos desglosados: una linea por anticipo aplicado al crear (registrado
      // por administracion, con su numero y fecha) y una por cada abono
      // (incluye la liquidacion, si ya se liquido).
      const moneda = (n) =>
        new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n);
      const filasAnticipos = await Promise.all(
        (a.anticiposAplicados || []).map(async (x) => {
          const importe = parseFloat(x.importe) || 0;
          if (!(importe > 0)) return null;
          const idAnt = x.anticipos?._id || x.anticipos;
          let etiqueta = "Anticipo";
          try {
            const { data: ant } = await axios.get(`${URL_ANTICIPOS}/${idAnt}`, { headers: auth });
            etiqueta = `Anticipo #${ant.idAnticipo} (${formatDate(ant.fecha)})`;
          } catch (e) {
            console.log(e);
          }
          return ["", "", etiqueta, moneda(-importe)];
        })
      );
      const filasAbonos = (abonosRes.data || [])
        .map((ab) => {
          const importe = parseFloat(ab.efectivo || 0) + parseFloat(ab.tdc || 0) + parseFloat(ab.transfer || 0);
          return importe > 0 ? ["", "", `${ab.concepto || "Abono"} (${formatDate(ab.fecha)})`, moneda(-importe)] : null;
        })
        .filter(Boolean);
      const filasPagos = [...filasAnticipos.filter(Boolean), ...filasAbonos];

      const doc = new jsPDF(); // A4, portrait, mm -- pagina completa, no ticket

      var img = new Image();
      img.src = "Logo-Sistemify-PDF.png";
      doc.addImage(img, "png", 8, 5, 18, 5);
      var img2 = new Image();
      img2.src = "logoInstitucion.png";
      doc.addImage(img2, "png", 10, 11, 20, 10);

      doc.setFontSize(16);
      doc.text(`Número de Apartado: ${a.consecutivo}`, 35, 15);

      doc.setFontSize(12);
      doc.text(`Vendedor:`, 120, 15);
      doc.text(`${a.colaborador}`, 150, 15);
      if (a.cajaNombre && a.cajaNombre !== "—") {
        doc.text(`Caja:`, 120, 20);
        doc.text(`${a.cajaNombre}`, 150, 20);
      }
      doc.text(`Entregado:`, 120, 25);
      doc.text(`${a.entregado}`, 150, 25);

      doc.setFontSize(8);
      doc.text(`Creado por: ${a.cajero || "—"}`, 120, 32);
      doc.text(`Fecha creado: ${a.fechaHora || a.fecha}`, 120, 37);

      doc.text(`Cliente: ${a.clientes}`, 10, 32);
      doc.text(`RFC: ${a.rfc}`, 10, 37);
      doc.text(`Direccion de Envio: ${a.calle || ""} #${a.numero_ext || ""} Int. ${a.numero_int || ""}`, 10, 47);
      doc.text(`Telefono: ${a.telefono || ""}`, 10, 52);
      doc.text(`Edo: ${a.estado || ""}, Ciudad: ${a.ciudad || ""}, CP: ${a.cp || ""}`, 10, 57);
      doc.text(`Del: ${a.delegacion || ""}, Col: ${a.colonia || ""}`, 10, 62);

      doc.setFontSize(12);
      doc.text(`Paqueteria: ${a.paqueteria || ""}`, 120, 50);
      doc.text(`Almacen: ${a.areaSurtido || a.area}`, 120, 57);

      doc.autoTable({
        head: [["Articulo", "Cant.", "Precio", "Total"]],
        body: dataPDFLimpia,
        styles: { fontSize: 10 },
        startY: 70,
        margin: { left: 10, right: 10 },
        foot: [
          ["", new Intl.NumberFormat("en-US").format(TK) + "Piezas", "Sub Total", new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.subTotal)],
          ["", "", "IVA", new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.iva)],
          ["", "", "Comision TDC", new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.comisionTDC)],
          ["", "", "Paquetería", new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.comisionFlete)],
          ["", "", `Desc ${a.descuento}%`, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(-(a.descuentoNumero || 0))],
          ...filasPagos,
          ["", "", "Saldo", new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.saldo)],
        ],
        showFoot: "lastPage",
      });

      doc.setFontSize(10);
      var lines = doc.splitTextToSize(`Observaciones ${a.observaciones || "NA"}`, 200);
      doc.text(10, doc.autoTable.previous.finalY + 10, lines);

      const finalY = doc.autoTable.previous.finalY + 10 + lines.length * 5 + 8;
      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      const avisoLines = doc.splitTextToSize(
        "Este documento es únicamente una cotización, no una factura ni comprobante de venta. " +
          "Tiene vigencia de 7 días naturales; vencido el plazo sin liquidación, se pierde el anticipo. " +
          "La facturación y el seguro de envío deben solicitarse anticipadamente a su asesor. " +
          "Los tiempos de entrega dependen de la paquetería elegida por el cliente, quien asume la " +
          "responsabilidad del paquete una vez entregado a esta. El seguro tiene costo adicional " +
          "según el valor de la mercancía.",
        180
      );

      // El recuadro se mide con el texto en vez de los 22mm fijos de antes:
      // este aviso es mucho mas largo y se desbordaba de la caja.
      const altoLinea = doc.getLineHeight() / doc.internal.scaleFactor;
      const altoAviso = avisoLines.length * altoLinea + 5;
      let yAviso = finalY;
      // Si ya no cabe al pie de la hoja se pasa completo a la siguiente, para
      // que no quede partido a la mitad.
      if (yAviso - 5 + altoAviso > 287) {
        doc.addPage();
        yAviso = 20;
      }

      doc.setDrawColor(200, 0, 0);
      doc.setLineWidth(0.5);
      doc.rect(10, yAviso - 5, 190, altoAviso);
      doc.setTextColor(200, 0, 0);
      doc.text(avisoLines, 15, yAviso);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
    }
  }



  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Tienda", field: "area", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaborador", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Entregado", field: "entregado", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (esAnticipos) {
      computedComments = computedComments.filter((e) => e.entregado !== "Si");
    }

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.condPago.toLowerCase().includes(search.toLowerCase()) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaborador.includes(selectedColaborador)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedAreaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idAreas.includes(selectedAreaFiltro)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    selectedFechaInicio,
    selectedFechaFin,
    selectedAreaFiltro
  ]);

  // ── Abonos embebidos (estilo Gloss, sin paso de validacion/autorizacion) ──
  function abrirAbonos(a) {
    setApartadoSel(a);
    setCajaAbono("");
    setAbonoData({
      efectivo: 0,
      tdc: 0,
      transfer: 0,
      destino: "NA",
      fechaTransfer: "NA",
      terminal: "NA",
      observaciones: "NA",
    });
    axios
      .get(`${URL_CAJAS}Area/${a.idAreas}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setCajasApartado((res.data || []).filter((c) => c.is_active === "Si"));
      })
      .catch((err) => console.log(err));
    cargaAbonosExistentes(a._id);
    toggleAbonos();
  }

  function cargaAbonosExistentes(idVenta) {
    setCargandoAbonos(true);
    axios
      .get(`${URL_ABONOS_TIENDAS}/ventasTiendas/${idVenta}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setAbonosExistentes((res.data || []).filter((ab) => ab.is_active !== "No"));
      })
      .catch((err) => {
        console.log(err);
        setAbonosExistentes([]);
      })
      .finally(() => setCargandoAbonos(false));
  }

  async function guardarAbono() {
    const importe =
      parseFloat(abonoData.efectivo || 0) +
      parseFloat(abonoData.tdc || 0) +
      parseFloat(abonoData.transfer || 0);

    if (importe <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Importe requerido",
        text: "Captura al menos una forma de pago con monto mayor a $0",
      });
      return;
    }
    if (!cajaAbono) {
      Swal.fire({
        icon: "warning",
        title: "Caja requerida",
        text: "Selecciona la caja donde se recibió el abono",
      });
      return;
    }
    const saldoActual = parseFloat(apartadoSel.saldo || 0);
    if (importe > saldoActual + 0.01) {
      Swal.fire({
        icon: "error",
        title: "Importe mayor al saldo",
        text: `El saldo pendiente es ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(saldoActual)}`,
      });
      return;
    }

    setGuardandoAbono(true);
    try {
      await axios.post(
        URL_ABONOS_TIENDAS,
        {
          fecha: moment().format("YYYY-MM-DD"),
          // "total" es el monto de ESTE abono (no el total de la venta).
          total: importe,
          areas: apartadoSel.idAreas,
          caja: cajaAbono,
          clientes: apartadoSel.idClientes,
          ventasTiendas: apartadoSel._id,
          efectivo: parseFloat(abonoData.efectivo || 0),
          tdc: parseFloat(abonoData.tdc || 0),
          transfer: parseFloat(abonoData.transfer || 0),
          destino: abonoData.destino,
          fechaTransfer: abonoData.fechaTransfer,
          terminal: abonoData.terminal,
          cortesia: 0,
          codigoAgrupado: uuidv4(),
          // "concepto" es un valor categorico, no texto libre: CorteTiendas.jsx
          // solo incluye en el corte los abonos con concepto EXACTO "Abono"
          // (linea ~259 de ese archivo). Cualquier otro texto queda invisible
          // en el corte sin importar la caja. El apartado al que pertenece ya
          // queda ligado via "ventasTiendas", no hace falta repetirlo aqui.
          concepto: "Abono",
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      const nuevoSaldo = parseFloat((saldoActual - importe).toFixed(2));

      await axios.patch(
        `${URL_VENTAS_TIENDAS}/${apartadoSel._id}`,
        { saldo: nuevoSaldo },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      setApartadoSel((prev) => (prev ? { ...prev, saldo: nuevoSaldo } : prev));
      setVentasTiendas((prev) =>
        prev.map((v) => (v._id === apartadoSel._id ? { ...v, saldo: nuevoSaldo } : v))
      );
      setComments((prev) =>
        prev.map((v) => (v._id === apartadoSel._id ? { ...v, saldo: nuevoSaldo } : v))
      );
      setAbonoData({
        efectivo: 0,
        tdc: 0,
        transfer: 0,
        destino: "NA",
        fechaTransfer: "NA",
        terminal: "NA",
        observaciones: "NA",
      });
      cargaAbonosExistentes(apartadoSel._id);

      // Ticket con el historial de pagos actualizado (incluye este abono).
      PDFOC(
        apartadoSel.fecha,
        apartadoSel.fechaHora,
        apartadoSel.colaborador,
        apartadoSel.clientes,
        apartadoSel.consecutivo,
        apartadoSel._id,
        apartadoSel.comisionTDC,
        apartadoSel.comisionFlete,
        apartadoSel.impuestos,
        apartadoSel.areaSurtido,
        apartadoSel.descuento,
        apartadoSel.descuentoNumero,
        apartadoSel.condPago,
        apartadoSel.idAreas,
        apartadoSel.subTotal,
        apartadoSel.iva,
        apartadoSel.total_general,
        "%",
        `${user.nombre} ${user.apellido}`,
        cajasApartado.find((c) => c._id === cajaAbono)?.nombre || "—",
        apartadoSel.anticipoAplicado,
        nuevoSaldo
      );

      Swal.fire({
        icon: "success",
        title: "Abono registrado",
        text: `Nuevo saldo: ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(nuevoSaldo)}`,
        timer: 2200,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({ icon: "error", title: "Oops...", text: "No se pudo guardar el abono" });
    } finally {
      setGuardandoAbono(false);
    }
  }

  // ── Liquidar embebido: jala el apartado, resta los abonos ya pagados,
  // pide forma de pago del resto; solo si el pago cubre
  // exactamente lo pendiente se descuenta inventario y se marca entregado ──
  function abrirLiquidar(a) {
    setApartadoSel(a);
    setCajaLiquidar("");
    setLiquidarData({
      efectivo: 0,
      tdc: 0,
      transfer: 0,
      destino: "NA",
      fechaTransfer: "NA",
      terminal: "NA",
    });
    axios
      .get(`${URL_CAJAS}Area/${a.idAreas}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setCajasApartado((res.data || []).filter((c) => c.is_active === "Si"));
      })
      .catch((err) => console.log(err));
    toggleLiquidar();
  }

  async function guardarLiquidacion() {
    const saldoActual = parseFloat(apartadoSel.saldo || 0);
    const totalAPagar = parseFloat(saldoActual.toFixed(2));
    const pagoFinal = parseFloat(
      (
        parseFloat(liquidarData.efectivo || 0) +
        parseFloat(liquidarData.tdc || 0) +
        parseFloat(liquidarData.transfer || 0)
      ).toFixed(2)
    );

    if (Math.abs(pagoFinal - totalAPagar) > 0.01) {
      Swal.fire({
        icon: "error",
        title: "El pago no coincide",
        text: `Debes cobrar exactamente ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(totalAPagar)} (el saldo pendiente). El inventario no se descuenta hasta que el pago cuadre exacto.`,
      });
      return;
    }
    if (totalAPagar > 0 && !cajaLiquidar) {
      Swal.fire({
        icon: "warning",
        title: "Caja requerida",
        text: "Selecciona la caja donde se recibió el pago final",
      });
      return;
    }

    setGuardandoLiquidar(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      if (totalAPagar > 0) {
        await axios.post(
          URL_ABONOS_TIENDAS,
          {
            fecha: moment().format("YYYY-MM-DD"),
            total: totalAPagar,
            areas: apartadoSel.idAreas,
            caja: cajaLiquidar,
            clientes: apartadoSel.idClientes,
            ventasTiendas: apartadoSel._id,
            efectivo: parseFloat(liquidarData.efectivo || 0),
            tdc: parseFloat(liquidarData.tdc || 0),
            transfer: parseFloat(liquidarData.transfer || 0),
            destino: liquidarData.destino,
            fechaTransfer: liquidarData.fechaTransfer,
            terminal: liquidarData.terminal,
            cortesia: 0,
            codigoAgrupado: uuidv4(),
            // Ver nota en guardarAbono(): "concepto" debe ser exactamente
            // "Abono" para que CorteTiendas.jsx lo incluya en el corte.
            concepto: "Abono",
          },
          { headers }
        );
      }

      const totalGeneralFinal = parseFloat(apartadoSel.total_general);

      // Registra el cargo formal en el cliente y marca la venta entregada.
      await axios.patch(
        `${URL_VENTAS_TIENDAS}EntregarApartado/${apartadoSel._id}`,
        {
          entregado: "Si",
          clientes: apartadoSel.idClientes,
          total_general: totalGeneralFinal,
        },
        { headers }
      );
      await axios.patch(
        `${URL_VENTAS_TIENDAS}/${apartadoSel._id}`,
        { saldo: 0 },
        { headers }
      );

      // Solo hasta aqui, con el pago cuadrado, se descuenta inventario.
      const resArticulos = await axios.get(
        `${URL_ARTICULOS_VENTAS_TIENDAS}Nota/${apartadoSel._id}`,
        { headers }
      );
      const lineas = resArticulos.data || [];
      for (const l of lineas) {
        await axios.patch(
          `${URL_ARTICULOS_VENTAS_TIENDAS}Entregar/${l._id}`,
          {
            cantidad: l.cantidad,
            inventarios: l.inventarios[0]._id,
            entregado: "Si",
          },
          { headers }
        );
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Liquidar Apartado",
          detalle: `Apartado ${apartadoSel.consecutivo} liquidado`,
          user: user.id,
        },
        { headers }
      );

      // Ticket final: la paqueteria ya viene en comisionFlete (se captura en Editar).
      PDFOC(
        apartadoSel.fecha,
        apartadoSel.fechaHora,
        apartadoSel.colaborador,
        apartadoSel.clientes,
        apartadoSel.consecutivo,
        apartadoSel._id,
        apartadoSel.comisionTDC,
        apartadoSel.comisionFlete,
        apartadoSel.impuestos,
        apartadoSel.areaSurtido,
        apartadoSel.descuento,
        apartadoSel.descuentoNumero,
        apartadoSel.condPago,
        apartadoSel.idAreas,
        apartadoSel.subTotal,
        apartadoSel.iva,
        totalGeneralFinal,
        "%",
        `${user.nombre} ${user.apellido}`,
        cajasApartado.find((c) => c._id === cajaLiquidar)?.nombre || "—",
        apartadoSel.anticipoAplicado,
        0
      );

      Swal.fire("Listo!", "Apartado liquidado con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo liquidar el apartado. Revisa e intenta de nuevo.",
      });
      setGuardandoLiquidar(false);
    }
  }

  function abrirEditar(a) {
    setApartadoSel(a);
    setEditarNuevoArticulo("");
    setEditarNuevoColor("");
    setEditarNuevoTalla("");
    setEditarNuevoCantidad(0);
    setEditarNuevoPrecio(0);
    setEditarInventarioArticulo([]);
    setEditarPaqueteria(parseFloat(a.comisionFlete || 0));
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

    axios
      .get(`${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${a._id}`, { headers })
      .then((res) => {
        const lineas = (res.data || []).map((l) => ({
          _id: l._id,
          idArticulo: l.articulos[0]._id,
          articuloNombre: l.articulos[0].codigo + " " + l.articulos[0].nombre,
          idColor: l.colores && l.colores[0] ? l.colores[0]._id : "",
          color: l.colores && l.colores[0] ? l.colores[0].name : "",
          idTalla: l.tallas && l.tallas[0] ? l.tallas[0]._id : "",
          talla: l.tallas && l.tallas[0] ? l.tallas[0].name : "",
          idInventario: l.inventarios && l.inventarios[0] ? l.inventarios[0]._id : null,
          cantidad: l.cantidad,
          precio: l.precio,
          isNew: false,
        }));
        setEditarLineas(lineas);
        setEditarLineasOriginalesIds(lineas.map((l) => l._id));
      })
      .catch((err) => console.log(err));

    if (editarArticulos.length === 0) {
      axios
        .get(`${URL_ARTICULOS}Activos`, { headers })
        .then((res) => setEditarArticulos(res.data || []))
        .catch((err) => console.log(err));
    }

    toggleEditar();
  }

  function cambiarCantidadLinea(id, nuevaCantidad) {
    setEditarLineas((prev) =>
      prev.map((l) => (l._id === id ? { ...l, cantidad: parseFloat(nuevaCantidad) || 0 } : l))
    );
  }

  function cambiarPrecioLinea(id, nuevoPrecio) {
    setEditarLineas((prev) =>
      prev.map((l) => (l._id === id ? { ...l, precio: parseFloat(nuevoPrecio) || 0 } : l))
    );
  }

  function eliminarLineaEditar(id) {
    setEditarLineas((prev) => prev.filter((l) => l._id !== id));
  }

  function seleccionaArticuloNuevo(idArt) {
    setEditarNuevoArticulo(idArt);
    setEditarNuevoColor("");
    setEditarNuevoTalla("");
    setEditarInventarioArticulo([]);
    if (!idArt || !apartadoSel) return;
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    axios
      .get(`${URL_INVENTARIOS}ArticuloArea/${idArt}/${apartadoSel.idAreas}`, { headers })
      .then((res) => setEditarInventarioArticulo(res.data || []))
      .catch((err) => console.log(err));
    const art = editarArticulos.find((a) => a._id === idArt);
    if (art) setEditarNuevoPrecio(art.venta || art.precio || 0);
  }

  function agregarLineaNueva() {
    if (!editarNuevoArticulo || !editarNuevoColor || !editarNuevoTalla || !editarNuevoCantidad) {
      Swal.fire({ icon: "warning", title: "Faltan datos", text: "Selecciona artículo, color, talla y cantidad" });
      return;
    }
    const inv = editarInventarioArticulo.find(
      (i) => i.colores[0]._id === editarNuevoColor && i.tallas[0]._id === editarNuevoTalla
    );
    if (!inv || parseFloat(inv.cantidad) < parseFloat(editarNuevoCantidad)) {
      Swal.fire({
        icon: "error",
        title: "Stock insuficiente",
        text: `Disponible: ${inv ? inv.cantidad : 0}`,
      });
      return;
    }
    const art = editarArticulos.find((a) => a._id === editarNuevoArticulo);
    setEditarLineas((prev) => [
      ...prev,
      {
        _id: `new-${uuidv4()}`,
        isNew: true,
        idArticulo: editarNuevoArticulo,
        articuloNombre: art ? art.codigo + " " + art.nombre : "",
        idColor: editarNuevoColor,
        color: inv.colores[0].name,
        idTalla: editarNuevoTalla,
        talla: inv.tallas[0].name,
        idInventario: inv._id,
        cantidad: parseFloat(editarNuevoCantidad),
        precio: parseFloat(editarNuevoPrecio) || 0,
      },
    ]);
    setEditarNuevoArticulo("");
    setEditarNuevoColor("");
    setEditarNuevoTalla("");
    setEditarNuevoCantidad(0);
    setEditarNuevoPrecio(0);
    setEditarInventarioArticulo([]);
  }

  async function guardarEdicion() {
    if (editarLineas.length === 0) {
      Swal.fire({ icon: "warning", title: "Sin piezas", text: "El apartado debe tener al menos una pieza" });
      return;
    }
    // Totales nuevos (piezas + paqueteria). Lo ya abonado no cambia; solo se
    // mueve lo que falta por pagar. Se calcula antes de tocar nada para no
    // dejar el apartado a medias si el nuevo total queda por debajo de lo abonado.
    const nuevaPaqueteria = parseFloat(parseFloat(editarPaqueteria || 0).toFixed(2));
    const nuevoTotalCantidad = editarLineas.reduce((s, l) => s + parseFloat(l.cantidad || 0), 0);
    const nuevoSubTotal = editarLineas.reduce((s, l) => s + parseFloat(l.cantidad || 0) * parseFloat(l.precio || 0), 0);
    const nuevoIva = parseFloat(((nuevoSubTotal * parseFloat(apartadoSel.impuestos || 0)) / 100).toFixed(2));
    const nuevoTotalGeneral = parseFloat(
      (nuevoSubTotal + nuevoIva + parseFloat(apartadoSel.comisionTDC || 0) + nuevaPaqueteria).toFixed(2)
    );
    const abonadoHastaAhora = parseFloat(apartadoSel.total_general || 0) - parseFloat(apartadoSel.saldo || 0);
    const nuevoSaldo = parseFloat((nuevoTotalGeneral - abonadoHastaAhora).toFixed(2));
    if (nuevoSaldo < -0.01) {
      Swal.fire({
        icon: "error",
        title: "Total menor a lo abonado",
        text: `El nuevo total (${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(nuevoTotalGeneral)}) es menor a lo que el cliente ya abonó (${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(abonadoHastaAhora)}).`,
      });
      return;
    }

    setGuardandoEditar(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      // 1. Eliminar renglones originales que ya no estan.
      for (const idOriginal of editarLineasOriginalesIds) {
        if (!editarLineas.find((l) => l._id === idOriginal)) {
          await axios.delete(`${URL_ARTICULOS_VENTAS_TIENDAS}/${idOriginal}`, { headers });
        }
      }
      // 2. Actualizar cantidad/precio de renglones existentes.
      for (const l of editarLineas.filter((l) => !l.isNew)) {
        await axios.patch(
          `${URL_ARTICULOS_VENTAS_TIENDAS}/${l._id}`,
          { cantidad: l.cantidad, precio: l.precio, total: parseFloat((l.cantidad * l.precio).toFixed(2)) },
          { headers }
        );
      }
      // 3. Crear renglones nuevos (mismo endpoint de creacion de apartado: no descuenta inventario).
      for (const l of editarLineas.filter((l) => l.isNew)) {
        await axios.post(
          `${URL_ARTICULOS_VENTAS_TIENDAS}Apartado`,
          {
            fecha: apartadoSel.fecha,
            ventasTiendas: apartadoSel._id,
            articulos: l.idArticulo,
            cantidad: l.cantidad,
            precio: l.precio,
            total: parseFloat((l.cantidad * l.precio).toFixed(2)),
            inventarios: l.idInventario,
            entregado: "No",
            colores: l.idColor,
            tallas: l.idTalla,
          },
          { headers }
        );
      }

      // 4. Guardar totales. El backend recalcula el saldo con lo abonado segun la
      // BD y ajusta el cargo del cliente (cargos/saldo) por la diferencia de total.
      await axios.patch(
        `${URL_VENTAS_TIENDAS}EditarApartado/${apartadoSel._id}`,
        {
          total_cantidad: nuevoTotalCantidad,
          subTotal: parseFloat(nuevoSubTotal.toFixed(2)),
          iva: nuevoIva,
          comisionFlete: nuevaPaqueteria,
          total_general: nuevoTotalGeneral,
        },
        { headers }
      );

      Swal.fire("Listo!", "Apartado actualizado con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo guardar la edición. Revisa e intenta de nuevo.",
        footer: error.response?.data?.message || "",
      });
      setGuardandoEditar(false);
    }
  }

  function cancelarNota(idNota) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Nota!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_VENTAS_TIENDAS}CancelApartado/${idNota}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
    }
  });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {/* Apartados: el boton del menu (BotonesTiendas) se muestra con
          user.apartados, asi que la pantalla debe abrir con ese mismo permiso.
          listadoVentasTiendas se conserva para no quitar acceso a quien ya entraba. */}
      {(esAnticipos ? user.apartadosAbonar : user.apartados || user.listadoVentasTiendas) ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {esAnticipos ? null : user.apartados ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ApartadosTiendasCreate"
                >
                  Nuevo Apartado
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Apartado
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuTiendas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ventas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* ── Modal Abonos: registrar anticipos de un apartado, sin paso de
              validacion/autorizacion — cuenta al instante en el corte ── */}
          <Modal size="md" isOpen={modalAbonos} toggle={toggleAbonos}>
            <ModalHeader toggle={toggleAbonos}>
              <h4>Abonos — Apartado {apartadoSel?.consecutivo}</h4>
            </ModalHeader>
            <ModalBody>
              {apartadoSel && (
                <>
                  <Row>
                    <Col md={4}>
                      <b>Cliente:</b> {apartadoSel.clientes}
                    </Col>
                    <Col md={4}>
                      <b>Total:</b>{" "}
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(apartadoSel.total_general)}
                    </Col>
                    <Col md={4}>
                      <b>Saldo pendiente:</b>{" "}
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(apartadoSel.saldo || 0)}
                    </Col>
                  </Row>
                  {parseFloat(apartadoSel.anticipoAplicado || 0) > 0 && (
                    <Row className="mt-2">
                      <Col md={12}>
                        <b>Anticipo aplicado al crear:</b>{" "}
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(apartadoSel.anticipoAplicado)}
                      </Col>
                    </Row>
                  )}
                  <hr />
                  <b>Abonos registrados</b>
                  {cargandoAbonos ? (
                    <Spinner size="sm" />
                  ) : abonosExistentes.length === 0 ? (
                    <p>Sin abonos todavía.</p>
                  ) : (
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Efectivo</th>
                          <th>TDC</th>
                          <th>Transfer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {abonosExistentes.map((ab) => (
                          <tr key={ab._id}>
                            <td>{formatDate(ab.fecha)}</td>
                            <td>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(ab.efectivo || 0)}</td>
                            <td>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(ab.tdc || 0)}</td>
                            <td>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(ab.transfer || 0)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  <hr />
                  <b>Nuevo abono</b>
                  <Row>
                    <Col md={4}>
                      <Label className="mr-sm-2">Caja</Label>
                      <Input
                        type="select"
                        value={cajaAbono}
                        onChange={(e) => setCajaAbono(e.target.value)}
                      >
                        <option value="">Selecciona Caja</option>
                        {cajasApartado.map((c) => (
                          <option key={c._id} value={c._id}>{c.nombre}</option>
                        ))}
                      </Input>
                    </Col>
                    <Col md={4}>
                      <Label className="mr-sm-2">Efectivo</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={abonoData.efectivo}
                        onChange={(e) => setAbonoData((prev) => ({ ...prev, efectivo: e.target.value }))}
                      />
                    </Col>
                    <Col md={4}>
                      <Label className="mr-sm-2">TDC</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={abonoData.tdc}
                        onChange={(e) => setAbonoData((prev) => ({ ...prev, tdc: e.target.value }))}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Label className="mr-sm-2">Transfer</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={abonoData.transfer}
                        onChange={(e) => setAbonoData((prev) => ({ ...prev, transfer: e.target.value }))}
                      />
                    </Col>
                    <Col md={8}>
                      <Label className="mr-sm-2">Observaciones</Label>
                      <Input
                        type="text"
                        value={abonoData.observaciones}
                        onChange={(e) => setAbonoData((prev) => ({ ...prev, observaciones: e.target.value }))}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {guardandoAbono ? (
                <Spinner size="sm" />
              ) : (
                <Button size="sm" color="success" onClick={guardarAbono}>
                  Guardar Abono
                </Button>
              )}
            </ModalFooter>
          </Modal>

          {/* ── Modal Liquidar: jala el apartado, resta abonos pagados, pide
              pago del resto; solo si cuadra exacto se descuenta
              inventario y se marca entregado ── */}
          <Modal size="md" isOpen={modalLiquidar} toggle={toggleLiquidar}>
            <ModalHeader toggle={toggleLiquidar}>
              <h4>Liquidar Apartado {apartadoSel?.consecutivo}</h4>
            </ModalHeader>
            <ModalBody>
              {apartadoSel && (
                <>
                  <Row>
                    <Col md={4}>
                      <b>Cliente:</b> {apartadoSel.clientes}
                    </Col>
                    <Col md={4}>
                      <b>Total venta:</b>{" "}
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(apartadoSel.total_general)}
                    </Col>
                    <Col md={4}>
                      <b>Saldo pendiente:</b>{" "}
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(apartadoSel.saldo || 0)}
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={6}>
                      <Label className="mr-sm-2">Caja</Label>
                      <Input
                        type="select"
                        value={cajaLiquidar}
                        onChange={(e) => setCajaLiquidar(e.target.value)}
                      >
                        <option value="">Selecciona Caja</option>
                        {cajasApartado.map((c) => (
                          <option key={c._id} value={c._id}>{c.nombre}</option>
                        ))}
                      </Input>
                    </Col>
                    <Col md={6}>
                      <Label className="mr-sm-2">Total a cobrar</Label>
                      <h5>
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
                          parseFloat(apartadoSel.saldo || 0)
                        )}
                      </h5>
                    </Col>
                  </Row>
                  <hr />
                  <b>Forma de pago del restante</b>
                  <Row>
                    <Col md={4}>
                      <Label className="mr-sm-2">Efectivo</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={liquidarData.efectivo}
                        onChange={(e) => setLiquidarData((prev) => ({ ...prev, efectivo: e.target.value }))}
                      />
                    </Col>
                    <Col md={4}>
                      <Label className="mr-sm-2">TDC</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={liquidarData.tdc}
                        onChange={(e) => setLiquidarData((prev) => ({ ...prev, tdc: e.target.value }))}
                      />
                    </Col>
                    <Col md={4}>
                      <Label className="mr-sm-2">Transfer</Label>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={liquidarData.transfer}
                        onChange={(e) => setLiquidarData((prev) => ({ ...prev, transfer: e.target.value }))}
                      />
                    </Col>
                  </Row>
                  <p className="text-muted" style={{ marginTop: "8px" }}>
                    El inventario solo se descuenta cuando el pago capturado cuadra exacto con el saldo. El cargo de paquetería se captura en Editar.
                  </p>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {guardandoLiquidar ? (
                <Spinner size="sm" />
              ) : (
                <Button size="sm" color="primary" onClick={guardarLiquidacion}>
                  Liquidar y Entregar
                </Button>
              )}
            </ModalFooter>
          </Modal>

          {/* ── Modal Editar: quitar/agregar prendas antes de liquidar ── */}
          <Modal size="lg" isOpen={modalEditar} toggle={toggleEditar}>
            <ModalHeader toggle={toggleEditar}>
              <h4>Editar Apartado {apartadoSel?.consecutivo}</h4>
            </ModalHeader>
            <ModalBody>
              {apartadoSel && (
                <>
                  <Table size="sm" bordered>
                    <thead>
                      <tr>
                        <th>Artículo</th>
                        <th>Color</th>
                        <th>Talla</th>
                        <th style={{ width: "80px" }}>Cant.</th>
                        <th style={{ width: "90px" }}>Precio</th>
                        <th>Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {editarLineas.map((l) => (
                        <tr key={l._id}>
                          <td>{l.articuloNombre}</td>
                          <td>{l.color}</td>
                          <td>{l.talla}</td>
                          <td>
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="1"
                              value={l.cantidad}
                              onChange={(e) => cambiarCantidadLinea(l._id, e.target.value)}
                            />
                          </td>
                          <td>
                            <Input
                              bsSize="sm"
                              type="number"
                              min="0"
                              step="any"
                              value={l.precio}
                              onChange={(e) => cambiarPrecioLinea(l._id, e.target.value)}
                            />
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
                              (parseFloat(l.cantidad) || 0) * (parseFloat(l.precio) || 0)
                            )}
                          </td>
                          <td>
                            <Button size="sm" color="danger" onClick={() => eliminarLineaEditar(l._id)}>
                              ×
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <hr />
                  <Row>
                    <Col md={4}>
                      <Label className="mb-0">Cargo de paquetería</Label>
                      <Input
                        bsSize="sm"
                        type="number"
                        min="0"
                        step="any"
                        value={editarPaqueteria}
                        onChange={(e) => setEditarPaqueteria(e.target.value)}
                      />
                    </Col>
                    <Col md={4}>
                      <Label className="mb-0">Nuevo total</Label>
                      <h6>
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
                          (() => {
                            const sub = editarLineas.reduce(
                              (s, l) => s + (parseFloat(l.cantidad) || 0) * (parseFloat(l.precio) || 0),
                              0
                            );
                            const iva = (sub * parseFloat(apartadoSel.impuestos || 0)) / 100;
                            return sub + iva + parseFloat(apartadoSel.comisionTDC || 0) + (parseFloat(editarPaqueteria) || 0);
                          })()
                        )}
                      </h6>
                    </Col>
                    <Col md={4}>
                      <Label className="mb-0">Ya abonado</Label>
                      <h6>
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
                          parseFloat(apartadoSel.total_general || 0) - parseFloat(apartadoSel.saldo || 0)
                        )}
                      </h6>
                    </Col>
                  </Row>

                  <hr />
                  <b>Agregar pieza</b>
                  <Row className="mt-1">
                    <Col md={4}>
                      <Label className="mb-0">Artículo</Label>
                      <Autocomplete
                        size="small"
                        value={
                          opcionesArticulosEditar.find(
                            (a) => a._id === editarNuevoArticulo
                          ) || null
                        }
                        onChange={(event, opcion) =>
                          seleccionaArticuloNuevo(opcion?._id || "")
                        }
                        options={opcionesArticulosEditar}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option?.junta || ""}
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=""
                            variant="outlined"
                            placeholder="Busca por código o nombre"
                            slotProps={{
                              input: {
                                ...params.InputProps,
                                style: {
                                  height: "31px",
                                  fontSize: "12px",
                                  padding: "0 30px 0 8px",
                                },
                              },
                              htmlInput: {
                                ...params.inputProps,
                                style: { padding: "0", fontSize: "12px" },
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option._id}>
                            {option.codigo} {option.nombre}
                          </li>
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mb-0">Color</Label>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={editarNuevoColor}
                        onChange={(e) => setEditarNuevoColor(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {[...new Map(editarInventarioArticulo.map((i) => [i.colores[0]._id, i.colores[0]])).values()].map((c) => (
                          <option key={c._id} value={c._id}>{c.name}</option>
                        ))}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Label className="mb-0">Talla</Label>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={editarNuevoTalla}
                        onChange={(e) => setEditarNuevoTalla(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {editarInventarioArticulo
                          .filter((i) => i.colores[0]._id === editarNuevoColor)
                          .map((i) => (
                            <option key={i.tallas[0]._id} value={i.tallas[0]._id}>
                              {i.tallas[0].name} (disp. {i.cantidad})
                            </option>
                          ))}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Label className="mb-0">Cantidad</Label>
                      <Input
                        bsSize="sm"
                        type="number"
                        min="0"
                        step="1"
                        value={editarNuevoCantidad}
                        onChange={(e) => setEditarNuevoCantidad(e.target.value)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label className="mb-0">Precio</Label>
                      <Input
                        bsSize="sm"
                        type="number"
                        min="0"
                        step="any"
                        value={editarNuevoPrecio}
                        onChange={(e) => setEditarNuevoPrecio(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <div className="mt-2">
                    <Button size="sm" color="success" onClick={agregarLineaNueva}>
                      Agregar
                    </Button>
                  </div>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {guardandoEditar ? (
                <Spinner size="sm" />
              ) : (
                <Button size="sm" color="warning" onClick={guardarEdicion}>
                  Guardar Cambios
                </Button>
              )}
            </ModalFooter>
          </Modal>

          <h3 align="center">{esAnticipos ? "Anticipos Tiendas" : "Reporte de Apartados"}</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

          
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAreaFiltro}
                onChange={(e) => {
                  setSelectedAreaFiltro(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                  if(a.activo == "Si"){
                  return (
                    <tr>
                      {/* <td>{a.activo}</td> */}
                      <td>{a.consecutivo}</td>
                      <td>{a.area}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.colaborador}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo || 0)}</td>
                      <td>
                        {a.entregado}
                        {a.entregado !== "Si" &&
                          parseFloat(a.total_general || 0) - parseFloat(a.saldo || 0) <= 0.01 && (
                            <>
                              {" "}
                              <Badge color="warning">Sin anticipo</Badge>
                            </>
                          )}
                      </td>
                      <td>
                            {esAnticipos && a.entregado !== "Si" && (
                              <>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="success"
                                  disabled={!parseFloat(a.saldo)}
                                  onClick={(e) => abrirAbonos(a)}
                                >
                                  Abonar
                                </Button>{" "}
                              </>
                            )}
                            {!esAnticipos && a.entregado !== "Si" && (
                              <>
                                {user.apartadosLiquidar && (
                                  <Button
                                    size="sm"
                                    className="btn"
                                    color="primary"
                                    onClick={(e) => abrirLiquidar(a)}
                                  >
                                    Liquidar
                                  </Button>
                                )}{" "}
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="warning"
                                  onClick={(e) => abrirEditar(a)}
                                >
                                  <i className="fas fa-pencil-alt"></i>
                                </Button>{" "}
                              </>
                            )}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => PDFCotizacion(a)}
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            {!esAnticipos && user.apartadosEliminar && a.entregado !== "Si" && (
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={(e) => cancelarNota(a._id)}
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            )}
                      </td>
                    
                    </tr>
                  );
                }else{
                  return (
                    <tr className="row-cancelled">
                      <td>{a.consecutivo}</td>
                      <td>{a.area}</td>
                      <td>{formatDate(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.user}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{a.entregado}</td>
                      <td>CANCELADA </td>
                  </tr>
                  )
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : (
        <div className="container">
          <h4 align="center">No tienes permiso para ver esta sección.</h4>
        </div>
      )}
      <br />


      {loader}
    </>
  );
}

export default ListadoApartadosTiendas;
